module.exports = __webpack_public_path__ + "static/img/4-1-4.b2250ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/4-1-4.png
// module id = /q4Z
// module chunks = 12